import Box from '@mui/material/Box';
import { SlideMetadataRow } from 'components/OrderSlidesList/SlideActionTabs/SlideMetadata/SlideMetadataRow/SlideMetadataRow';

export const ScienceInfoSection = ({ sampleData, classes }) =>
  sampleData.length ? (
    <Box className={classes.root}>
      {sampleData.map(({ label, value, keyTooltip, valueTooltip, link }) => (
        <SlideMetadataRow
          key={label}
          label={label}
          value={value}
          keyTooltip={keyTooltip}
          valueTooltip={valueTooltip}
          link={link}
        />
      ))}
    </Box>
  ) : (
    <Box className={classes.centered}>No science info available</Box>
  );
